import {
	PickersActionBar,
	DateTimePickerProps,
	DateTimePicker
} from "@mui/x-date-pickers-pro";
import { Dayjs } from "dayjs";
import { BaseTextFieldProps } from "@mui/material/TextField/TextField";

export interface AavoDateTimePickerProps
	extends DateTimePickerProps<Dayjs>,
		Pick<BaseTextFieldProps, "size"> {
	errorMessage?: string;
}

export const AavoDateTimePicker = ({
	slots,
	slotProps,
	size,
	errorMessage,
	...other
}: AavoDateTimePickerProps) => {
	const slotPropsWrapped = {
		...slotProps,
		textField: {
			...{
				size: size,
				error: errorMessage !== undefined,
				helperText: errorMessage,
			},
			...slotProps?.textField,
		},
	};

	return (
		<DateTimePicker
			slotProps={slotPropsWrapped}
			slots={{
				...slots,
				// eslint-disable-next-line @typescript-eslint/no-unused-vars
				actionBar: ({ actions, ...other }) => {
					return (
						<PickersActionBar
							actions={["today", "clear", "cancel", "accept"]}
							{...other}
						/>
					);
				},
			}}
			{...other}
		/>
	);
};
